import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Apollo, gql } from 'apollo-angular';

import * as contracts from '../contracts';
import { AccountOwnerMapper } from './mappers';

@Injectable()
export class AccountOwnerService implements contracts.IAccountOwnerService {
  constructor(private apollo: Apollo) {}

  getAccountOwnerList(
    request: contracts.GetAccountOwnerListRequest
  ): Observable<contracts.GetAccountOwnerListResponse> {
    const pagination = {
      skip: request.skip,
      limit: request.limit,
    };

    const filter: { name?: { contains: string } } = {};
    if (request.name) {
      filter.name = { contains: request.name };
    }

    return this.apollo
      .query<any>({
        query: gql(`query listSfAccountOwner(
            $filter: SfAccountOwnerFilterInput
            $pagination: PaginationInput!
            $sorting: SfAccountOwnerSortInput
          ){
            listSfAccountOwner(
              filter: $filter
              pagination: $pagination
              sorting: $sorting
            ) {
              accountOwners {
                id
                name
                email
              }
            }
          }
        `),
        variables: {
          filter,
          pagination,
          sorting: { name: true },
        },
      })
      .pipe(
        map((svcResp) => {
          const response = new contracts.GetAccountOwnerListResponse();
          if (svcResp.data && svcResp.data.listSfAccountOwner) {
            response.entities = svcResp.data.listSfAccountOwner.accountOwners.map((item: any) =>
              AccountOwnerMapper.Instance().accountOwnerDtoToAccountOwner(item)
            );
          }
          return response;
        })
      );
  }
}
